<template>
	<div>
		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->

		<input class="displayno" type="file" id="pre_file" v-on:change="getFilePath" />

		<a id="pre_downlink"></a>
		<a id="pre_loodlink" target="_blank"></a>
	</div>
</template>

<script>
	import api from '@/utils/type.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	import {
		JsonCheck
	} from '@/utils/method.js';

	export default {
		name: "hj-file",
		data() {
			return {
				//文件
				file_list_main: [],
				/*add 2022-02-20 图片存储*/
				sheet_no: '',
				row_id: 0,
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "0",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				sel_filename: '',
				p1: '',
				p2: '',
				p3: '',
			}
		},
		created() {


		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input激活');

		},
		deactivated: function() {
			// console.log('keep-alive 组件激活时调用 hj-input停用');
			this.file_name = "";
			this.file_data = "";
			this.file_up = "";
			this.file_url = "";
			this.file_src = "";
			this.file_size = "";
			this.file_action = "";
			this.blockSize = "";
			this.file_backdata = "";
			this.sel_filename = '';
			this.p1 = "";
			this.p2 = "";
			this.p3 = "";
		},
		methods: {
			fun_select: function(f_type, f_url, f_action, f_p1, f_p2, f_p3, f_id, sheet_no, f_src) {
				// console.log('001 file_action=' + f_action);
				this.file_action = "";
				this.p1 = "";
				this.p2 = "";
				this.p3 = "";
				this.row_id = 0;
				this.file_src = '';
				this.sheet_no = '';

				switch (f_type) {
					case 'look':
						this.pre_look_file(f_url);
						break;
					case 'sel':
						this.pre_sel_file();
						break;
					case 'up':
						this.file_action = f_action;
						this.p1 = f_p1;
						this.p2 = f_p2;
						this.p3 = f_p3;
						this.row_id = f_id;
						this.sheet_no = sheet_no;
						this.pre_up_file();
						break;
					case 'del':
						this.file_action = f_action;
						this.p1 = f_p1;
						this.p2 = f_p2;
						this.p3 = f_p3;
						this.row_id = f_id;
						this.sheet_no = sheet_no;
						this.file_src = f_src;
						this.pre_del_file();
						break;
					default:
						this.$message({
							message: '操作方式=' + f_type + ' 未配置!',
							type: 'warning'
						});
						break;

				}

			},
			val_back: function(step) {
				this.$emit('file-event', step, this.file_up, this.file_url, this.file_src, this.sel_filename);
			},
			//附件操作 start //////////////////////////////////////
			pre_look_file: function(f_url) {
				this.file_url = "";
				this.file_name = "";

				this.file_url = BackSpecial(f_url);
				// console.log('点击预览附件' + this.file_url);

				let tt = '';
				tt = this.file_url;
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				// 可以通过判断附件数量大于1时,通过小弹出进行编辑操作

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('pre_loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("pre_downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			// 点击上传附件
			pre_sel_file: function() {
				this.file_data = "";
				this.file_backdata = "";

				let fileobj = document.getElementById('pre_file');
				// document.selection.clear(); //清空附件选择 测试无效！
				fileobj.value = '';
				// fileobj.outerHTML = fileobj.outerHTML; //重新初始化了fileobj的html
				fileobj.click();
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('pre_file');
				// //console.log('点击选择结果');
				// //console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 20000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// //console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.sel_filename = '';
					this.sel_filename = name;
					this.file_name = JsonCheck(name);
					this.val_back('sel_file');
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// //console.log(tmpFile);   //连标签原样输出了
					// //console.log(tmpFile.value);   //图片路径


					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// //console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			pre_del_file: function() {
				//console.log('点击删除附件');

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";

				postdata =
					'{"action":"' + this.file_action + '_del","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';

				// ////console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// ////console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					this.file_up = res.data.msg;

					this.val_back('del_end');

				});

			},
			fun_del_file_three: function() {

				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					//console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

						this.file_name = '';
						this.file_url = '';
						this.file_src = '';
						this.file_data = '';
						this.file_backdata = '';

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			pre_up_file: async function() {
				let temp_name = '';
				temp_name = JsonCheck(this.file_name);
				let random_name = GetRandom();
				this.file_name = random_name + temp_name;

				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				//console.log('base64文件大小=' + this.file_data.length)
				// 一块文件的大小
				// console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0 && this.file_data.length <= this.blockSize) {
					// console.log('小文件上传');
					this.fun_up_file_min();
				} else if (this.file_data.length > this.blockSize) {
					// console.log('大文件上传');
					// this.element_loading = true;



					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// //console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// //console.log('p3=' + this.p3);

				this.val_back('up_start');
				var postdata = "";

				postdata =
					'{"action":"data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.file_name +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					this.file_data +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				// console.log(JSON.parse(postdata));

				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					// console.log('上传反馈', res);
					res = res.data;
					if (res && res.statue === "1") {
						var js = JSON.parse(res.result)

						if (js.status == 1) {
							that.file_up = "上传成功";

							that.file_url = BackSpecial(js.f_url);
							that.file_src = BackSpecial(js.f_src);

							this.$message({
								message: '上传成功',
								type: 'success'
							});
						} else {
							this.file_up = "上传失败";

							this.$message({
								message: '上传失败\n\r' + js.msg,
								type: 'success'
							});
						}
					} else {
						this.$message({
							message: '上传失败\n\r' + res.message,
							type: 'success'
						});
					}


					this.val_back('up_end');

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				this.file_size = maxFileLength;
				// ////console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// ////console.log('上传长度=' + temp_data.size);
					// ////console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						////console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// ////console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// ////console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);
				// 这里保存文件数据。因为是切片追加模式，而且不写路径。所以row_id和sheet_no 不用传

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.file_name +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no + '","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';

				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';
				// File_block 这个方法只保存文件...不保存路径到数据库
				return new Promise((resolve, reject) => {
					// ////console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// ////console.log(res);
						// console.log('上传反馈2', res);
						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// ////console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// ////console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				////console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";
				// File_SavePath 专门保存路径
				postdata =
					'{"action":"data_save_file","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					this.file_name +
					'","upfile_type":"' +
					this.file_type +
					'","upfile_size":"' +
					this.file_size +
					'","upfile_data":"' +
					"" +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'"}';

				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					console.log('大文件', res);
					res = res.data;
					this.element_loading = false;


					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + js.msg,
							type: 'success'
						});
					}

					this.val_back('up_end');


				});

			}
		}
	}
</script>

<style>

</style>